<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditEmployeeModal"
        class="bg-black fixed h-screen bg-opacity-70 inset-0 z-50 w-full"
      >
        <form
          @submit.prevent="update"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full overflow-y-auto"
          style="height: 100%"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-50 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Edit Employee</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="edit_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ edit_error }}
            </div>
          </transition>

          <div class="p-2">
            <div class="grid grid-cols-2">
              <div class="text-sm col-span-1">
                <label class="block pb-1">Employee No.</label>
                <input
                  v-model="info.EmployeeNo"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-full w-full"
                />
              </div>
            </div>
          </div>

          <div class="p-2">
            <p class="font-bold pb-2">Basic Information</p>
            <div class="grid grid-cols-1 sm:lg:grid-cols-2 lg:grid-cols-3 gap-5">
              <div class="text-sm">
                <label class="block pb-1">Full Name</label>
                <input
                  v-model="info.Fullname"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-full w-full"
                />
              </div>

              <div class="text-sm">
                <label class="block pb-1">Gender</label>
                <select
                  v-model="info.Gender"
                  required
                  class="p-2 bg-gray-200 rounded-full w-full"
                >
                  <option
                    :value="gender"
                    v-for="(gender, index) in saved_genders"
                    :key="index"
                  >
                    {{ gender }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="p-2">
            <p class="font-bold pb-2">Contact Information</p>
            <div class="grid grid-cols-1 sm:lg:grid-cols-2 lg:grid-cols-3 gap-5">
              <div class="text-sm">
                <label class="block pb-1">Username</label>
                <input
                  v-model="info.Username"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-full w-full"
                />
              </div>
              <div class="text-sm">
                <label class="block pb-1">Work Email</label>
                <input
                  v-model="info.WorkEmail"
                  required
                  type="email"
                  class="p-2 bg-gray-200 rounded-full w-full"
                />
              </div>
              <div class="text-sm">
                <label class="block pb-1">Work Phone</label>
                <input
                  v-model="info.WorkPhoneNumber"
                  required
                  type="tel"
                  class="p-2 bg-gray-200 rounded-full w-full"
                />
              </div>
            </div>
          </div>

          <div class="p-2">
            <p class="font-bold pb-2">Job Information</p>
            <div class="grid grid-cols-1 sm:lg:grid-cols-2 lg:grid-cols-3 gap-5">
              <div class="text-sm">
                <label class="block pb-1">Employment Type</label>
                <select
                  v-model="info.EmploymentTypeId"
                  required
                  class="p-2 bg-gray-200 rounded-full w-full"
                >
                  <option
                    v-for="(jobType, index) in saved_employment_types"
                    :key="index"
                  >
                    {{ jobType.Name }}
                  </option>
                </select>
              </div>

              <div
                class="text-sm"
                v-if="info.EmploymentTypeId.toLowerCase() === 'contract'"
              >
                <label class="block pb-1">Start Date</label>
                <input
                  v-model="info.StartDate"
                  type="date"
                  class="p-2 bg-gray-200 rounded-full w-full"
                />
              </div>

              <div
                class="text-sm"
                v-if="info.EmploymentTypeId.toLowerCase() === 'contract'"
              >
                <label class="block pb-1">End Date</label>
                <input
                  v-model="info.EndDate"
                  type="date"
                  class="p-2 bg-gray-200 rounded-full w-full"
                />
              </div>

              <div class="text-sm">
                <label class="block pb-1">Employment Status</label>
                <select
                  v-model="info.EmploymentStatusId"
                  required
                  class="p-2 bg-gray-200 rounded-full w-full"
                >
                  <option
                    v-for="(jobStatus, index) in saved_employment_status"
                    :key="index"
                  >
                    {{ jobStatus.Name }}
                  </option>
                </select>
              </div>

              <div class="text-sm">
                <label class="block pb-1">Job Grade</label>
                <select
                  v-model="info.JobGradeId"
                  required
                  class="p-2 bg-gray-200 rounded-full w-full"
                >
                  <option
                    v-for="(jobGrade, index) in saved_job_grades"
                    :key="index"
                  >
                    {{ jobGrade.Name }}
                  </option>
                </select>
              </div>

              <div class="text-sm">
                <label class="block pb-1">Role</label>
                <select
                  v-model="info.RoleId"
                  required
                  class="p-2 bg-gray-200 rounded-full w-full"
                >
                  <option v-for="(role, index) in saved_roles" :key="index">
                    {{ role.Name }}
                  </option>
                </select>
              </div>

              <div class="text-sm">
                <label class="block pb-1">Date Of Joining</label>
                <input
                  v-model="info.DateOfJoining"
                  required
                  type="date"
                  class="p-2 bg-gray-200 rounded-full w-full"
                />
              </div>

              <div class="text-sm">
                <label class="block pb-1">Can Signin</label>
                <el-checkbox
                  v-model="info.CanSignIn"
                  class="p-2 bg-gray-200 rounded-md w-full"
                  >Yes</el-checkbox
                >
              </div>
            </div>
          </div>

          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "@/components/loader/loader.vue";
import decryptData from "@/utils/decrypt";
import { mapGetters } from "vuex";

export default {
  name: "EditEmployeeModal",
  props: ["showEditEmployeeModal", "selectedEmployee", "refresh"],
  components: { Loader },
  data() {
    return {
      loading: false,
      edit_error: null,
      initialCanSignIn: null,
      saved_employment_types: [],
      saved_employment_status: [],
      saved_job_grades: [],
      saved_roles: [],
      saved_genders: ["Male", "Female", "Other"],
      info: {
        EmployeeNo: "",
        Fullname: "",
        Username: "",
        EmploymentTypeId: "",
        EmploymentStatusId: "",
        JobGradeId: "",
        RoleId: "",
        WorkEmail: "",
        WorkPhoneNumber: "",
        Gender: "",
        DateOfJoining: "",
        CanSignIn: true,
        StartDate: "",
        EndDate: "",
      },
    };
  },
  watch: {
    selectedEmployee(newVal) {
      if (newVal) {
        this.populateForm(newVal);
      }
    },
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  created() {
    this.getSavedData();
    if (this.selectedEmployee) {
      this.populateForm(this.selectedEmployee);
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    populateForm(employee) {
      this.info.EmployeeNo = employee.EmployeeNo || "";
      this.info.Fullname =
        decryptData(employee.Fullname, this.$decryptionKey) ||
        employee.Fullname ||
        "";
      this.info.Gender = employee.Gender
        ? decryptData(employee.Gender, this.$decryptionKey) || employee.Gender
        : "";
      this.info.Username =
        decryptData(employee.Username, this.$decryptionKey) ||
        employee.Username ||
        "";
      this.info.WorkEmail =
        decryptData(employee.WorkEmail, this.$decryptionKey) ||
        employee.WorkEmail ||
        "";
      this.info.WorkPhoneNumber =
        decryptData(employee.WorkPhoneNumber, this.$decryptionKey) ||
        employee.WorkPhoneNumber ||
        "";
      this.info.EmploymentTypeId = employee.EmployementTypeName || "";
      this.info.EmploymentStatusId = employee.EmploymentStatusName || "";
      this.info.JobGradeId = employee.JobGradeName || "";
      this.info.RoleId = employee.RoleName || "";
      this.info.DateOfJoining = employee.DateOfJoining
        ? employee.DateOfJoining.split("T")[0]
        : "";
      this.info.CanSignIn =
        employee.CanSignIn !== undefined ? employee.CanSignIn : true;
      this.initialCanSignIn = this.info.CanSignIn;
      this.info.StartDate = employee.StartDate
        ? employee.StartDate.split("T")[0]
        : "";
      this.info.EndDate = employee.EndDate
        ? employee.EndDate.split("T")[0]
        : "";
    },
    async update() {
      this.loading = true;
      this.edit_error = null;

      const headers = {
        Authorization: `Bearer ${this.getToken}`,
        "Content-Type": "application/json",
      };

      const employeeType = this.saved_employment_types.find(
        (t) => t.Name.trim().toLowerCase() === this.info.EmploymentTypeId.trim().toLowerCase()
      );
      const employeeStatus = this.saved_employment_status.find(
        (s) => s.Name.trim().toLowerCase() === this.info.EmploymentStatusId.trim().toLowerCase()
      );
      const jobGrade = this.saved_job_grades.find(
        (g) => g.Name.trim().toLowerCase() === this.info.JobGradeId.trim().toLowerCase()
      );
      const role = this.saved_roles.find(
        (r) => r.Name.trim().toLowerCase() === this.info.RoleId.trim().toLowerCase()
      );

      const calls = [
        axios.put(
          `${this.getOrganization}/employee/general/${this.$ApiVersion}/edit`,
          JSON.stringify({
            Id: this.selectedEmployee.Id,
            FullNames: this.info.Fullname,
            Gender: this.info.Gender,
          }),
          { headers }
        ),
        axios.put(
          `${this.getOrganization}/employee/work/information/${this.$ApiVersion}/edit`,
          JSON.stringify({
            EmployeeId: this.selectedEmployee.Id,
            EmployeeNo: this.info.EmployeeNo,
            WorkEmail: this.info.WorkEmail,
            WorkPhoneNumber: this.info.WorkPhoneNumber,
            Username: this.info.Username,
            DateofJoining: this.info.DateOfJoining,
            EmployementTypeId: employeeType?.employmentTypeId || null,
            EmployementStatusId: employeeStatus?.employmentStatusId || null,
            JobGradeId: jobGrade?.Id || null,
            RoleId: role?.Id || null,
          }),
          { headers }
        ),
      ];

      if (this.info.CanSignIn !== this.initialCanSignIn) {
        calls.push(
          axios.put(
            `${this.getOrganization}/employee/${this.$ApiVersion}/cansign`,
            JSON.stringify({
              EmployeeId: this.selectedEmployee.Id,
              CanSignIn: this.info.CanSignIn,
            }),
            { headers }
          )
        );
      }

      try {
        const responses = await Promise.all(calls);
        this.loading = false;
        const failed = responses.find((r) => r.data.StatusCode !== 200);
        if (failed) {
          this.edit_error = failed.data.StatusMessage;
        } else {
          this.$notify({
            title: "Success",
            message: "Employee updated successfully",
            type: "success",
          });
          if (this.refresh) this.refresh();
          this.$emit("close");
        }
      } catch (error) {
        this.loading = false;
        this.edit_error = error.message;
      }
    },
    getSavedData() {
      this.loading = true;
      const endpoints = [
        `${this.getOrganization}/setup/employment/type/${this.$ApiVersion}/request`,
        `${this.getOrganization}/setup/employment/status/${this.$ApiVersion}/request`,
        `${this.getOrganization}/setup/jobgrade/${this.$ApiVersion}/request`,
        `${this.getOrganization}/role/${this.$ApiVersion}/query`,
      ];
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      Promise.all(endpoints.map((endpoint) => axios.get(endpoint, options)))
        .then(
          axios.spread((...response) => {
            this.loading = false;
            this.saved_employment_types = response[0].data.Data;
            this.saved_employment_status = response[1].data.Data;
            this.saved_job_grades = response[2].data.Data;
            this.saved_roles = response[3].data.Data;
          })
        )
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
